import { AuthProvider } from './../../providers/auth/auth';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { CoinsProvider } from './../../providers/coins/coins';
import { Portfolio } from './../../models/Portfolio';
import { Component, ViewChild, ElementRef, Input, ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'portfolio-summary',
  templateUrl: 'portfolio-summary.html'
})
export class PortfolioSummaryComponent {

  @Input('portfolio') portfolio: Portfolio;
  @ViewChild('chartCol') chartCol: ElementRef;
  chartWidth: number;
  chartHeight: number;
  constructor(
    public CP: CoinsProvider,
    public navCtrl: NavController,
    public cdRef: ChangeDetectorRef,
    public auth: AuthProvider
  ) {

  }

  ngAfterViewInit(){
    if(this.chartCol){
      this.chartWidth = this.chartCol.nativeElement.clientWidth;
      this.chartHeight = 100;
    }
  }

  ngAfterViewChecked(){
    this.cdRef.detectChanges();
  }

  stopProp(event: Event){
    event.stopPropagation();
  }

}



// WEBPACK FOOTER //
// ./src/components/portfolio-summary/portfolio-summary.ts